<template>
    <div class="payment-history">
        <h1>{{ $t('payment_history.title') }}</h1>
        <ul class="year-filter">
            <li v-for="(item, index) in [
                'all', ...years
            ]" :key="index" :class="{
                'active': year === item
            }" @click="year = item">{{ item === 'all' ? $t('all') : item }}</li>
        </ul>
        <div class="reo-table">
            <div class="thead">
                <li>{{ $t('payment_history.id_label') }}</li>
                <li>{{ $t('payment_history.date_label') }}</li>
                <li>{{ $t('payment_history.total_label') }}</li>
                <li>{{ $t('payment_history.plan_label') }}</li>
                <li>{{ $t('payment_history.status_label') }}</li>
                <li></li>
            </div>
            <div class="tbody">
                <ul v-for="(payment, index) in paymentList" :key="index">
                    <li>#{{ payment.id }}</li>
                    <li>{{ $t( 'date_format.default' ,{
                        
                        year: timeResolve( payment.createdAt ).year,
                        month: timeResolve( payment.createdAt ).month,
                        day: timeResolve( payment.createdAt ).dateOfMonth
                            
                    }) }}</li>
                    <li>
                        <span :class="{ 'del sub-note': Number(payment.refundingAmount) > 0 || Number(payment.refundedAmount) > 0 }">
                            {{ `${payment.currency} ${payment.amount}` }}
                        </span>
                        <template v-if="Number(payment.refundingAmount) > 0">
                            <br />
                            <span class="refunding-amount">
                                {{ `${payment.currency} ${payment.refundingAmount}` }} {{ $t('payment_history.refunding') }}
                            </span>
                        </template>
                        <template v-else-if="Number(payment.refundedAmount) > 0">
                            <br />
                            <span>
                                {{ `${payment.currency} ${payment.restAmount}` }}
                            </span>
                        </template>
                    </li>
                    <li>
                        <span>
                            <span class="payment-product" v-for="(item, index) in payment.items" :key="index">
                                {{ item.name }}
                                <br/>
                                <span class="sub-note">
                                    ({{ $tc( `cycle_short.${item.details.cycle.standard.interval.unit}`, item.details.cycle.standard.interval.frequency, {

                                        count: item.details.cycle.standard.interval.frequency

                                    }) }})
                                    *
                                    {{ item.quantity }}
                                </span>
                            </span>
                        </span>
                    </li>
                    <li>{{ $t(`payment_status.${payment.status}`) }}</li>
                    <li>
                        <a class="ui-button primary-button" v-if="payment.status === paymentStatus.PENDING" :href="payment.redirectLink">
                            {{ $t('payment_history.pay_now') }}
                        </a>
                        <router-link class="text-link invoice" v-else-if="payment.status === paymentStatus.REFUNDED || payment.status === paymentStatus.COMPLETED || payment.status === paymentStatus.REFUNDING || payment.status === paymentStatus.MANUAL_REFUNDING" :to="`/user/invoice/${payment.id}/`" target="_blank">
                            {{ $t('payment_history.invoice') }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="reo-table-mobile">
            <ul v-for="(payment, index) in paymentList" :key="index">
                <li>
                    <label>{{ $t('payment_history.id_label') }}</label>
                    <span>#{{ payment.id }}</span>
                </li>
                <li>
                    <label>{{ $t('payment_history.date_label') }}</label>
                    <span>{{ $t( 'date_format.default' ,{
                        
                        year: timeResolve( payment.createdAt ).year,
                        month: timeResolve( payment.createdAt ).month,
                        day: timeResolve( payment.createdAt ).dateOfMonth
                            
                    }) }}</span>
                </li>
                <li>
                    <label>{{ $t('payment_history.total_label') }}</label>
                    <span>
                        <span :class="{ 'del sub-note': Number(payment.refundingAmount) > 0 || Number(payment.refundedAmount) > 0 }">
                            {{ `${payment.currency} ${payment.amount}` }}
                        </span>
                        <template v-if="Number(payment.refundingAmount) > 0">
                            <br />
                            <span>
                                {{ `${payment.currency} ${payment.refundingAmount}` }} {{ $t('payment_history.refunding') }}
                            </span>
                        </template>
                        <template v-else-if="Number(payment.refundedAmount) > 0">
                            <br />
                            <span>
                                {{ `${payment.currency} ${payment.restAmount}` }}
                            </span>
                        </template>
                    </span>
                </li>
                <li>
                    <label>{{ $t('payment_history.plan_label') }}</label>
                    <span>
                        <span class="payment-product" v-for="(item, index) in payment.items" :key="index">
                            {{ item.name }}
                            ({{ $tc( `cycle_short.${item.details.cycle.standard.interval.unit}`, item.details.cycle.standard.interval.frequency, {

                                count: item.details.cycle.standard.interval.frequency

                            }) }})
                            *
                            {{ item.quantity }}</span>
                    </span>
                </li>
                <li>
                    <label>{{ $t('payment_history.status_label') }}</label>
                    <span>
                        <a class="ui-button primary-button" v-if="payment.status === paymentStatus.PENDING" :href="payment.redirectLink">
                            {{ $t('payment_history.pay_now') }}
                        </a>
                        <span v-else>
                            {{ $t(`payment_status.${payment.status}`) }}
                        </span>
                        <router-link class="text-link invoice" v-if="payment.status === paymentStatus.REFUNDED || payment.status === paymentStatus.COMPLETED || payment.status === paymentStatus.REFUNDING || payment.status === paymentStatus.MANUAL_REFUNDING" :to="`/user/invoice/${payment.id}/`" target="_blank">
                            {{ $t('payment_history.invoice') }}
                        </router-link>
                    </span>
                </li>
            </ul>
        </div>
        <infiniteLoading spinner="spiral" class="loading" @infinite="infiniteHandler" v-if="hasMore"></infiniteLoading>
        <a href="javascript:void(0);" v-if="hasMore" class="more-payments" @click="getHistory">
            <span>{{ $t('payment_history.load_more') }}</span>
            <i class="icon-icon_arrow-down"></i>
        </a>
        <a href="javascript:void(0);" v-if="paymentList.length > 20" class="less-payments" @click="showless">
            <span>{{ $t('payment_history.show_less') }}</span>
            <i class="icon-icon_arrow-up"></i>
        </a>
    </div>
</template>

<script>
import { getPaymentHistory } from '@/api/cart';
import { timeResolve } from '@/common/js/date';
import InfiniteLoading from 'vue-infinite-loading';
import { payment as paymentStatus } from '@/config/status';

export default {

    components: {

        InfiniteLoading

    },

    data () {

        let now = new Date().getFullYear();
        let year = 2018;
        let years = [];
        while ( year < now + 1 ) {

            years.unshift( year );
            year++;

        }
        return {

            paymentList: [],
            hasMore: false,
            per: 20,
            years,
            year: 'all',
            paymentStatus,
            products: {}

        };

    },
    async created () {

        await this.getHistory();

    },
    methods: {

        async getHistory ( year ) {

            try {

                let paymentList = this.paymentList;
                let data;
                if ( paymentList.length === 0 ) {
    
                    data = await getPaymentHistory( this.year );
    
                } else {
    
                    let id = paymentList[ paymentList.length - 1 ].id;
                    data = await getPaymentHistory( this.year, id );
    
                }
                this.hasMore = data.length === this.per;
                paymentList.push( ...data );

            } catch ( err ) {

                console.error( err );

            }

        },
        timeResolve ( date ) {

            return timeResolve( date );

        },
        date ( date ) {

            let dateObj = timeResolve( date );
            return `${dateObj.month}/${dateObj.dateOfMonth}/${dateObj.year}`;

        },
        async infiniteHandler ( $state ) {

            await this.getHistory();
            $state.loaded();

        },
        showless () {

            this.paymentList.splice( this.per );
            $( document ).scrollTop( 0 );

        }

    },
    watch: {

        year ( year ) {

            let _year = year === 'all' ? '' : year;
            this.paymentList = [];
            this.getHistory( _year );

        }

    }

};
</script>

<style scoped lang="less">
.payment-history{
    max-width: 1000px;
    margin: 0 auto;
    padding: 1rem 0;
    @media @mobile{
        padding: 1rem 0 0.88rem;
    }
    .sub-note{
        color: #777;
    }
    h1{
        font-size: 0.36rem;
        font-weight: 500;
        margin-bottom: 0.6rem;
        text-align: center;
        @media @mobile{
            font-size: 0.5rem;
            font-weight: 700;
            text-align: left;
            padding: 0 15px;
        }
    }
    .year-filter{
        color: #777;
        font-size: 0.18rem;
        margin-bottom: 0.3rem;
        @media @mobile{
            padding: 0 15px;
            font-size: 0.28rem;
            margin-bottom: 0.4rem;
        }
        li{
            font-weight: 500;
            float: left;
            position: relative;
            cursor: pointer;
            padding-bottom: 0.05rem;
            @media @mobile{
                padding-bottom: 0.1rem;
            }
            &.active{
                color: @theme;
                &:after{
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    display: block;
                    width: 100%;
                    height: 2px;
                    background-color: @theme;
                }
            }
        }
        li+li{
            margin-left: 0.6rem;
        }
        &:after{
            content: '';
            display: table;
            clear: both;
        }
    }
    .reo-table{
        max-width: 1000px;
        margin: 0 auto;
        margin-bottom: 0.3rem;
        @media @mobile{
            display: none;
        }
        li{
            display: table-cell;
            line-height: 0.2rem;
            padding-top: 0.2rem;
            padding-bottom: 0.2rem;
            box-sizing: border-box;
            margin: 0;
            font-size: 0.16rem;
            vertical-align: middle;
            padding-left: .3rem;
            @media @pc{
                &:first-child{
                    width: 1.5rem;
                    padding-left: 0.1rem;
                }
                &:nth-child(2){
                    width: 1.7rem;
                }
                &:nth-child(3){
                    width: 1.6rem;
                }
                &:nth-child(4){
                    width: 1.75rem;
                }
                &:nth-child(5){
                    width: 1.55rem;
                }
                &:nth-child(6){
                    width: 1.9rem;
                    padding-left: 0;
                    text-align: center;
                    font-weight: 500;
                    padding: 0;
                }
            }
            .action{
                color: @theme;
                cursor: pointer;
            }
            .text-link.invoice{
                font-size: 0.16rem;
                font-weight: 500;
                &:hover{
                    text-decoration: underline;
                }
            }
        }
        .thead{
            background-color: #FAFBFC;
            font-size: 0.16rem;
            border-top: 1px solid #E2E2E2;
            li{
                font-weight: 500;
            }
        }
        .tbody{
            li{
                border-top: 1px solid #E2E2E2;
            }
        }
    }
    .refunding-amount{
        font-size: 0.14rem;
    }
    .more-payments{
        font-weight: 500;
        font-size: 0.16rem;
        color: @theme;
        @media @mobile{
            margin-left: 15px;
            display: none;
        }
        i{
            vertical-align: middle;
            margin-left: 0.1rem;
            font-size: 0.12rem;
        }
    }
    .less-payments{
        font-size: 0.26rem;
        font-weight: 500;
        color: @theme;
        margin-left: 15px;
        i{
            font-size: 0.16rem;
            vertical-align: middle;
            margin-left: 0.1rem;
        }
        @media @pc{
            display: none;
        }
    }
    .reo-table-mobile{
        @media @pc{
            display: none;
        }
        @media @mobile{
            display: block;
            margin-bottom: 0.3rem;
            ul{
                padding: .6rem 15px;
                background-color: #FAFBFC;
                font-size: 0;
                border: 1px solid #f8f8f8;
            }
            ul + ul,
            li + li{
                margin-top: .3rem;
            }
            li label{
                font-size: .26rem;
                width: 2.94rem;
                color: #333;
                font-weight: 500;
                margin-bottom: 0;
                display: inline-block;
                vertical-align: top;
            }
            li>span{
                font-size: .26rem;
                display: inline-block;
            }
            .text-link.invoice{
                font-size: 0.26rem;
                display: block;
                font-weight: 500;
            }
        }
    }
    @media @pc{
        .loading{
            display: none;
        }
    }
    .payment-product{
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/paymentHistory/index.vue